export interface StripeProduct {
  id: string;
  productId: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
  price: string;
  currency: string;
  interval?: 'month' | 'year';
}

export type PlanId = 'boost' | 'scale';

export const stripeProducts: StripeProduct[] = [
  {
    id: 'boost_monthly',
    productId: 'prod_TNy8jOMBKSwldP',
    priceId: 'price_1SRCBnENcVsHr4WIuic9CJOK',
    name: 'Boost',
    description: 'Accès aux fonctionnalités Boost avec facturation mensuelle',
    mode: 'subscription',
    price: '$24.00',
    currency: 'USD',
    interval: 'month'
  },
  {
    id: 'boost_yearly',
    productId: 'prod_TNy8jOMBKSwldP',
    priceId: 'price_1SRCBnENcVsHr4WIuic9CJOK',
    name: 'Boost',
    description: 'Accès aux fonctionnalités Boost avec facturation annuelle',
    mode: 'subscription',
    price: '$240.00',
    currency: 'USD',
    interval: 'year'
  },
  {
    id: 'scale_monthly',
    productId: 'prod_TNyAA6s2Ni4yPK',
    priceId: 'price_1SRCDrENcVsHr4WI7BwPORhF',
    name: 'Scale',
    description: 'Accès aux fonctionnalités Scale avec facturation mensuelle',
    mode: 'subscription',
    price: '$39.00',
    currency: 'USD',
    interval: 'month'
  },
  {
    id: 'scale_yearly',
    productId: 'prod_TNyAA6s2Ni4yPK',
    priceId: 'price_1SRCDrENcVsHr4WI7BwPORhF',
    name: 'Scale',
    description: 'Accès aux fonctionnalités Scale avec facturation annuelle',
    mode: 'subscription',
    price: '$390.00',
    currency: 'USD',
    interval: 'year'
  }
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};

export const getProductById = (id: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.id === id);
};

export const getMonthlyProducts = (): StripeProduct[] => {
  return stripeProducts.filter(product => product.interval === 'month');
};

export const getYearlyProducts = (): StripeProduct[] => {
  return stripeProducts.filter(product => product.interval === 'year');
};

export const getProductsByPlan = (planType: PlanId): StripeProduct[] => {
  return stripeProducts.filter(product => 
    product.name.toLowerCase().includes(planType.toLowerCase())
  );
};

export const getPlanVariant = (plan: PlanId, interval: 'month' | 'year'): StripeProduct | undefined => {
  return stripeProducts.find(product => 
    product.name.toLowerCase() === plan && product.interval === interval
  );
};

const parsePriceValue = (price: string): number => {
  const numeric = Number(price.replace(/[^0-9.]/g, ''));
  return Number.isFinite(numeric) ? numeric : 0;
};

// Helper function to get savings percentage for yearly plans
export const getYearlySavings = (planType: PlanId): number => {
  const monthlyProduct = getPlanVariant(planType, 'month');
  const yearlyProduct = getPlanVariant(planType, 'year');
  
  if (!monthlyProduct || !yearlyProduct) return 0;
  
  const monthlyPrice = parsePriceValue(monthlyProduct.price);
  const yearlyPrice = parsePriceValue(yearlyProduct.price);
  
  const monthlyCost = monthlyPrice * 12;
  const savings = monthlyCost - yearlyPrice;
  
  return Math.round((savings / monthlyCost) * 100);
};